// Catalogue filtering only: it never writes table search/sort or selects a lens.
export default function lensCatalogue(entries = [], standalone = false) {
  const previousFocus = globalThis.document?.activeElement;
  const normalize = text => String(text).trim().toLocaleLowerCase();
  return {
    entries, query: '', open: false,
    init() { if (standalone) this.$nextTick(() => this.$refs.search.focus()); },
    destroy() { if (standalone && previousFocus?.isConnected) previousFocus.focus(); },
    matches(entry) {
      const query = normalize(this.query);
      return !query || [entry.label, ...entry.path].some(value => normalize(value).includes(query));
    },
    groupVisible(path, mode = null) {
      const modes = mode === null ? null : Array.isArray(mode) ? mode : [mode];
      return this.entries.some(entry => (modes === null || modes.includes(entry.mode)) && path.every((part, i) => entry.path[i] === part) && this.matches(entry));
    },
    expanded(path) { return Boolean(this.query.trim()) || path.length === 1; },
    count() { return this.entries.filter(entry => this.matches(entry)).length; },
    toggle() {
      if (this.open) return this.close(this.$refs.button);
      this.open = true;
      this.$nextTick(() => this.$refs.search.focus());
    },
    close(focusAfter) {
      this.open = false; this.query = '';
      focusAfter?.focus();
    },
    reset() { this.$wire.selectLens(null); this.close(this.$refs.button); },
    focusRow(event, direction) {
      event.preventDefault();
      const rows = Array.from(this.$refs.results.querySelectorAll('[data-catalogue-row]')).filter(row => !row.disabled && row.getClientRects().length);
      const current = rows.indexOf(document.activeElement);
      const index = current < 0 ? (direction > 0 ? 0 : rows.length - 1) : (current + direction + rows.length) % rows.length;
      rows[index]?.focus();
    },
  };
}
